(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9603],{

/***/ 8266:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search",
      function () {
        return __webpack_require__(39402);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 39402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_search; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/toggled/dist/toggled.esm.js
var toggled_esm = __webpack_require__(67866);
// EXTERNAL MODULE: ./src/components/index.ts + 138 modules
var components = __webpack_require__(36357);
// EXTERNAL MODULE: ./src/components/filters/components/filters-provider/filters-provider.tsx + 1 modules
var filters_provider = __webpack_require__(56855);
// EXTERNAL MODULE: ./src/components/filters/filters-queries.ts
var filters_queries = __webpack_require__(77066);
// EXTERNAL MODULE: ./src/gql/queries/index.ts + 45 modules
var queries = __webpack_require__(98);
// EXTERNAL MODULE: ./node_modules/@apollo/react-hooks/lib/react-hooks.esm.js
var react_hooks_esm = __webpack_require__(18499);
// EXTERNAL MODULE: ./src/layouts/index.ts + 17 modules
var layouts = __webpack_require__(63409);
// EXTERNAL MODULE: ./src/utils/index.ts + 24 modules
var utils = __webpack_require__(90644);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/truck/label/index.tsx
var label = __webpack_require__(67734);
;// CONCATENATED MODULE: ./src/components/page-title-with-total/PageTitleWithTotal.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: baseline;\n  display: flex;\n  gap: ",
        "px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var TitleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aba9827d-0"
})(_templateObject(), function(props) {
    return props.theme.spacing.compact;
});
function PageTitleWithTotal(props) {
    var title = props.title, total = props.total;
    var shouldShowTotal = !(0,lodash.isNil)(total);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* default */.Z, {
                as: "h1",
                $textStyle: "h4Semibold",
                children: title
            }),
            shouldShowTotal && /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* default */.Z, {
                as: "span",
                children: "(".concat(total, ")")
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/page-title-with-total/index.tsx


;// CONCATENATED MODULE: ./src/screens/search/header/index.desktop.tsx

function index_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  padding: ",
        "px;\n  padding-bottom: ",
        "px;\n  width: 100%;\n"
    ]);
    index_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4e9cabb-0"
})(index_desktop_templateObject(), function(props) {
    return props.theme.spacing.comfortable;
}, function(props) {
    return props.theme.spacing.cozy;
});
function Desktop(props) {
    var title = props.title, numOfHints = props.numOfHints;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitleWithTotal, {
                title: title,
                total: numOfHints
            })
        })
    });
}
/* harmony default export */ var index_desktop = (Desktop);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/truck/icon/index.tsx + 1 modules
var icon = __webpack_require__(63216);
// EXTERNAL MODULE: ./src/truck/theme.ts
var theme = __webpack_require__(78904);
;// CONCATENATED MODULE: ./src/screens/search/header/index.mobile.js

function index_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  padding: ",
        "px;\n  width: 100%;\n\n  > svg:first-child {\n    margin-right: ",
        "px;\n  }\n"
    ]);
    index_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var index_mobile_TitleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d83fa7d6-0"
})(index_mobile_templateObject(), theme/* default.spacing.comfortable */.Z.spacing.comfortable, theme/* default.spacing.cozy */.Z.spacing.cozy);
function Header(props) {
    var title = props.title, numOfHints = props.numOfHints;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_mobile_TitleContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                    type: "arrow-left",
                    color: "black",
                    onClick: function() {
                        return router.back();
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitleWithTotal, {
                    title: title,
                    total: numOfHints
                })
            ]
        })
    });
}
/* harmony default export */ var index_mobile = (Header);

;// CONCATENATED MODULE: ./src/screens/search/header/index.js






var header_Header = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Media */.pU, {
        desktop: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_desktop, (0,_object_spread/* default */.Z)({}, props)),
        mobile: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_mobile, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var header = (header_Header);

;// CONCATENATED MODULE: ./src/screens/search/index.tsx













var mapper = function(value, key) {
    return "".concat(key, ":").concat(value);
};
var mapFiltersForQuery = function(filters) {
    return (0,lodash.map)(filters, mapper);
};
var SearchScreen = function(props) {
    var ref, ref1, ref2, ref3;
    var metaInfo = props.metaInfo, isParentCategory = props.isParentCategory, _term = props.term, term = _term === void 0 ? "" : _term, page = props.page, initialFilters = props.initialFilters, subcategoryName = props.subcategoryName, categoryName = props.categoryName;
    var filters = mapFiltersForQuery(initialFilters);
    var queryVariables = react.useMemo(function() {
        return {
            term: term,
            page: page,
            filters: filters
        };
    }, [
        filters,
        term,
        page
    ]);
    var catalogSearchQueryResponse = (0,react_hooks_esm/* useQuery */.aM)(queries/* catalogSearchQuery */.pY, {
        variables: queryVariables,
        onError: function(apolloError) {
            return (0,utils/* notifySentry */.Yw)(apolloError);
        }
    });
    var ref4;
    var paginationInfo = (ref4 = (ref = catalogSearchQueryResponse.data) === null || ref === void 0 ? void 0 : (ref1 = ref.catalogSearch) === null || ref1 === void 0 ? void 0 : ref1.pageInfo) !== null && ref4 !== void 0 ? ref4 : {};
    var ref5;
    var products = (ref5 = (ref2 = catalogSearchQueryResponse.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.catalogSearch) === null || ref3 === void 0 ? void 0 : ref3.items) !== null && ref5 !== void 0 ? ref5 : [];
    var headerTitle = subcategoryName || categoryName || '"'.concat(term, '"');
    var fetchMoreProducts = react.useCallback(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(page) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            catalogSearchQueryResponse.fetchMore({
                                updateQuery: utils/* queryUpdater */.c_,
                                variables: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queryVariables), {
                                    page: page
                                })
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(page) {
            return _ref.apply(this, arguments);
        };
    }(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        queryVariables
    ]);
    var _page;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Meta */.h_, {
                title: metaInfo.title,
                image: metaInfo.image,
                url: metaInfo.url,
                description: metaInfo.description,
                asCanonical: isParentCategory,
                prevPage: paginationInfo.prevPage,
                nextPage: paginationInfo.nextPage
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* MainLayout */.Zn, {
                loading: catalogSearchQueryResponse.loading,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header, {
                        title: headerTitle,
                        numOfHints: paginationInfo.total
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Catalog */.gm, {
                        products: products,
                        pagination: {
                            pageStart: (_page = paginationInfo.page) !== null && _page !== void 0 ? _page : 1,
                            hasMore: paginationInfo.hasNextPage,
                            initialLoad: true,
                            loadMore: (0,lodash.debounce)(fetchMoreProducts, 500)
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var search = (SearchScreen);

// EXTERNAL MODULE: ./node_modules/apollo-client/bundle.esm.js
var bundle_esm = __webpack_require__(61462);
// EXTERNAL MODULE: ./src/hooks/use-filters-state.ts
var use_filters_state = __webpack_require__(98280);
// EXTERNAL MODULE: ./node_modules/styled-breakpoints/index.js
var styled_breakpoints = __webpack_require__(94698);
// EXTERNAL MODULE: ./src/hooks/index.ts + 31 modules
var hooks = __webpack_require__(81251);
// EXTERNAL MODULE: ./src/truck/button/index.tsx + 2 modules
var truck_button = __webpack_require__(48721);
// EXTERNAL MODULE: ./src/truck/utils/index.ts + 8 modules
var truck_utils = __webpack_require__(14250);
;// CONCATENATED MODULE: ./src/components/filters/components/filter-button/filter-button.tsx

function filter_button_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-color: transparent;\n  color: ",
        ";\n  height: ",
        "px;\n  padding-left: ",
        "px;\n  padding-right: ",
        "px;\n  width: auto;\n  ",
        "\n\n  & > svg {\n    fill: ",
        ";\n    width: ",
        "px;\n    height: ",
        "px;\n  }\n\n  &:hover,\n  &:focus {\n    background: ",
        ";\n    border-color: ",
        ";\n    color: ",
        ";\n\n    & > svg {\n      fill: ",
        ";\n    }\n  }\n"
    ]);
    filter_button_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(truck_button/* default.Ghost */.Z.Ghost).withConfig({
    componentId: "sc-46ba3814-0"
})(filter_button_templateObject(), function(props) {
    return props.theme.palette.primary40;
}, function(props) {
    return props.theme.spacing.cozy * 5;
}, function(props) {
    return props.theme.spacing.cozy * 1.5;
}, function(props) {
    return props.theme.spacing.cozy * 1.5;
}, (0,truck_utils/* getTextStyle */.BN)("h5Semibold"), function(props) {
    return props.theme.palette.primary40;
}, function(props) {
    return props.theme.spacing.cozy * 2.5;
}, function(props) {
    return props.theme.spacing.cozy * 2.5;
}, function(props) {
    return props.theme.colors.white;
}, function(props) {
    return props.theme.palette.primary40;
}, function(props) {
    return props.theme.palette.primary40;
}, function(props) {
    return props.theme.palette.primary40;
});
function FilterButton(props) {
    var onClick = props.onClick;
    var selectedTags = (0,hooks/* useFilters */.mN)().selectedTags;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledButton, {
        onClick: onClick,
        children: [
            "Filtrar (",
            selectedTags.length,
            ")"
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/filters/components/filter-button/index.ts


// EXTERNAL MODULE: ./src/components/floating-header/index.ts + 1 modules
var floating_header = __webpack_require__(42234);
// EXTERNAL MODULE: ./src/components/modal/index.tsx + 4 modules
var modal = __webpack_require__(40519);
// EXTERNAL MODULE: ./src/truck/overlay/index.tsx + 1 modules
var overlay = __webpack_require__(2969);
// EXTERNAL MODULE: ./src/hooks/use-filters.tsx
var use_filters = __webpack_require__(42900);
// EXTERNAL MODULE: ./src/errors/index.ts + 4 modules
var errors = __webpack_require__(10335);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-collapsible/dist/index.mjs + 8 modules
var dist = __webpack_require__(67091);
;// CONCATENATED MODULE: ./src/components/filters/components/filter-item/filter-item-layout.tsx


function filter_item_layout_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  padding: ",
        "px ",
        "px;\n\n  & > span {\n    font-size: ",
        "px;\n  }\n"
    ]);
    filter_item_layout_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var HeaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8416b51f-0"
})(filter_item_layout_templateObject(), function(props) {
    return props.theme.spacing.cozy;
}, function(props) {
    return props.theme.spacing.cozy * 1.5;
}, function(props) {
    return props.theme.spacing.cozy * 1.75;
});
var StyledCollapsibleRoot = (0,styled_components_browser_esm/* default */.ZP)(dist/* Root */.fC).withConfig({
    componentId: "sc-8416b51f-1"
})(_templateObject1());
function FilterItemLayout(props) {
    var title = props.title, children = props.children;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(function() {
        var _defaultIsOpen;
        return (_defaultIsOpen = props.defaultIsOpen) !== null && _defaultIsOpen !== void 0 ? _defaultIsOpen : false;
    }), 2), isOpen = ref[0], setIsOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCollapsibleRoot, {
        open: isOpen,
        onOpenChange: function(open) {
            return setIsOpen(open);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Trigger */.xz, {
                asChild: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* default */.Z, {
                            as: "span",
                            $textStyle: "h6Semibold",
                            $color: "grayscale80",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                            type: isOpen ? "caret-up" : "caret-down",
                            size: "sm",
                            color: "grayscale80"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Content */.VY, {
                children: children
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/truck/checkbox/index.tsx + 1 modules
var truck_checkbox = __webpack_require__(79412);
;// CONCATENATED MODULE: ./src/components/filters/components/filter-item/filter-item-lists.tsx

function filter_item_lists_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  padding: ",
        "px ",
        "px;\n\n  & > span {\n    font-size: ",
        "px;\n  }\n"
    ]);
    filter_item_lists_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledCheckbox = (0,styled_components_browser_esm/* default */.ZP)(truck_checkbox/* default */.Z).withConfig({
    componentId: "sc-76d154d6-0"
})(filter_item_lists_templateObject(), function(props) {
    return props.theme.spacing.cozy;
}, function(props) {
    return props.theme.spacing.comfortable;
}, function(props) {
    return props.theme.spacing.cozy * 1.75;
});
function FilterItemLists(props) {
    var productFilter = props.productFilter;
    var toggleListFilterValue = (0,use_filters_state/* useFiltersState */.$)().toggleListFilterValue;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: productFilter.values.map(function(productFilterValue) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCheckbox, {
                color: "primary",
                checked: productFilterValue.selected,
                onChange: function() {
                    return toggleListFilterValue(productFilterValue.serializedFilter);
                },
                textStyle: "h6Regular",
                children: productFilterValue.label
            }, productFilterValue.key);
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
;// CONCATENATED MODULE: ./src/components/filters/components/filter-item/filter-item-price-ranges.tsx





function filter_item_price_ranges_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  gap: ",
        "px;\n  grid-template-columns: 1fr 1fr;\n  padding: ",
        "px ",
        "px;\n"
    ]);
    filter_item_price_ranges_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var FilterItemPriceRangesContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9f945b06-0"
})(filter_item_price_ranges_templateObject(), function(props) {
    return props.theme.spacing.comfortable;
}, function(props) {
    return props.theme.spacing.cozy;
}, function(props) {
    return props.theme.spacing.comfortable;
});
function FilterItemPriceRanges(props) {
    var productFilter = props.productFilter;
    var setRangeFilter = (0,use_filters_state/* useFiltersState */.$)().setRangeFilter;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(function() {
        var minimum = (0,lodash.find)(productFilter.values, {
            key: "minimum"
        });
        var maximum = (0,lodash.find)(productFilter.values, {
            key: "maximum"
        });
        return {
            minimum: minimum.value ? minimum.value : null,
            maximum: maximum.value ? maximum.value : null
        };
    }), 2), state = ref[0], setState = ref[1];
    var setRangeFilterValues = function() {
        return setRangeFilter(productFilter.target, state.minimum, state.maximum);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterItemPriceRangesContainer, {
        children: productFilter.values.map(function(productFilterRangeType) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PriceInput */.tV, {
                value: state[productFilterRangeType.key],
                name: productFilterRangeType.key,
                placeholder: productFilterRangeType.label,
                onBlur: setRangeFilterValues,
                onChange: function(floatValue) {
                    setState(function(prevState) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), (0,_define_property/* default */.Z)({}, productFilterRangeType.key, floatValue));
                    });
                },
                onKeyDown: function(event) {
                    if (event.keyCode === constants/* keyCodes.ENTER */.Do.ENTER) {
                        setRangeFilterValues();
                    }
                }
            }, productFilterRangeType.key);
        })
    });
}

;// CONCATENATED MODULE: ./src/components/filters/components/content/content.tsx

function content_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  overflow-y: auto;\n"
    ]);
    content_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var content_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9a3a2cbb-0"
})(content_templateObject(), function(props) {
    return props.theme.colors.white;
});
function Content(props) {
    var productFilters = props.productFilters;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(content_Container, {
        children: productFilters.map(function(productFilter) {
            switch(productFilter.type){
                case "list":
                    {
                        var hasSelectedValues = (0,lodash.some)(productFilter.values, "selected");
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterItemLayout, {
                            title: productFilter.label,
                            defaultIsOpen: hasSelectedValues,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterItemLists, {
                                productFilter: productFilter
                            })
                        }, productFilter.key);
                    }
                case "range":
                    {
                        var hasValues = (0,lodash.some)(productFilter.values, function(item) {
                            return !(0,lodash.isNil)(item.value);
                        });
                        /**
             * We need to re-mount when the values were changed and
             * re-initialize the state of the FilterItemPriceRanges
             * component.
             */ var key = (0,lodash.map)(productFilter.values, "value").join(",");
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterItemLayout, {
                            title: productFilter.label,
                            defaultIsOpen: hasValues,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterItemPriceRanges, {
                                productFilter: productFilter
                            }, key)
                        }, productFilter.key);
                    }
                default:
                    {
                        console.error(new errors/* UnsupportedValueError */.PW(productFilter.type));
                        return null;
                    }
            }
        })
    });
}

// EXTERNAL MODULE: ./src/types/product-filters.ts
var product_filters = __webpack_require__(8952);
// EXTERNAL MODULE: ./src/components/filters/components/filters-provider/filters-serialize.ts
var filters_serialize = __webpack_require__(72534);
;// CONCATENATED MODULE: ./src/components/filters/components/selected-filter-tags/selected-filter-tags.tsx

function selected_filter_tags_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: ",
        "px;\n"
    ]);
    selected_filter_tags_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var StyledSelectedFilterTagsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-614669fc-0"
})(selected_filter_tags_templateObject(), function(props) {
    return props.theme.spacing.cozy;
});
function SelectedFilterTags(props) {
    var className = props.className;
    var ref = (0,use_filters_state/* useFiltersState */.$)(), toggleListFilterValue = ref.toggleListFilterValue, setRangeFilter = ref.setRangeFilter;
    var selectedTags = (0,use_filters/* useFilters */.m)().selectedTags;
    if ((0,lodash.isEmpty)(selectedTags)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSelectedFilterTagsContainer, {
        className: className,
        children: selectedTags.map(function(selected) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Tag */.Vp, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* TagLabel */.Sn, {
                        children: selected.label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* TagCloseButton */.SD, {
                        onClick: function() {
                            if (selected.type === product_filters/* IProductFilterType.LIST */.J.LIST) {
                                toggleListFilterValue(selected.serializedFilter);
                            } else {
                                var target = (0,filters_serialize/* deserializeFilterValues */.u)(selected.serializedFilter).target;
                                setRangeFilter(target, null, null);
                            }
                        }
                    })
                ]
            }, "selected-filter-tag-".concat(selected.serializedFilter));
        })
    });
}

;// CONCATENATED MODULE: ./src/components/filters/components/selected-filter-tags/index.ts


;// CONCATENATED MODULE: ./src/components/filters/components/header/header.tsx

function header_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n  padding: ",
        "px;\n"
    ]);
    header_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function header_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-shrink: 0;\n  justify-content: space-between;\n"
    ]);
    header_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: ",
        "px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        "px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-80a0b829-0"
})(header_templateObject(), function(props) {
    return props.theme.spacing.cozy * 1.5;
});
var StyledTitleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-80a0b829-1"
})(header_templateObject1());
var StyledSelectedFilterTags = (0,styled_components_browser_esm/* default */.ZP)(SelectedFilterTags).withConfig({
    componentId: "sc-80a0b829-2"
})(_templateObject2(), function(props) {
    return props.theme.spacing.comfortable;
});
var StyledAction = (0,styled_components_browser_esm/* default */.ZP)(components/* Action */.aU).withConfig({
    componentId: "sc-80a0b829-3"
})(_templateObject3(), function(props) {
    return props.theme.spacing.cozy * 1.75;
});
function header_header_Header(props) {
    var className = props.className;
    var selectedTags = (0,hooks/* useFilters */.mN)().selectedTags;
    var clearFilters = (0,use_filters_state/* useFiltersState */.$)().clearFilters;
    var hasSelectedTags = !(0,lodash.isEmpty)(selectedTags);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTitleContainer, {
                className: className,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* default */.Z, {
                        as: "h4",
                        $textStyle: "h5Semibold",
                        $color: "grayscale80",
                        children: "Filtrar por"
                    }),
                    hasSelectedTags && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAction, {
                        $color: "info",
                        onClick: function() {
                            return clearFilters();
                        },
                        $textStyle: "h6Regular",
                        children: "Limpiar filtros"
                    })
                ]
            }),
            hasSelectedTags && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSelectedFilterTags, {})
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/filters/components/header/index.ts


;// CONCATENATED MODULE: ./src/components/filters/filters.tsx

function filters_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  display: flex;\n  flex-direction: column;\n  z-index: 100;\n"
    ]);
    filters_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var filters_StyledContainer = styled_components_browser_esm/* default.aside.withConfig */.ZP.aside.withConfig({
    componentId: "sc-2c2734ae-0"
})(filters_templateObject(), function(props) {
    return props.theme.colors.white;
});
function Filters(props) {
    var className = props.className, children = props.children;
    var productFilters = (0,use_filters/* useFilters */.m)().productFilters;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(filters_StyledContainer, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_header_Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                productFilters: productFilters
            }),
            children
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/filters/components/footer/footer.tsx

function footer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  bottom: 0;\n  box-shadow: 0px -2px 5px rgba(0, 0, 0, 0.08);\n  flex-shrink: 0;\n  left: 0;\n  padding: ",
        "px;\n  position: sticky;\n  right: 0;\n\n  ",
        " {\n    position: static;\n  }\n"
    ]);
    footer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var footer_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-335ec0f-0"
})(footer_templateObject(), function(props) {
    return props.theme.spacing.comfortable;
}, (0,styled_breakpoints.up)("lg"));
function Footer(props) {
    var onShowClick = props.onShowClick;
    var totalOfResults = (0,use_filters_state/* useFiltersState */.$)().totalOfResults;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(truck_button/* default */.Z, {
            color: "secondary",
            onClick: function() {
                return onShowClick();
            },
            children: [
                "Mostrar ",
                totalOfResults,
                " productos"
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/filters/components/footer/index.ts


;// CONCATENATED MODULE: ./src/components/filters/components/filters-mobile-modal/filters-mobile-modal.tsx

function filters_mobile_modal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n"
    ]);
    filters_mobile_modal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function filters_mobile_modal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-y: hidden;\n  padding: 0;\n"
    ]);
    filters_mobile_modal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function filters_mobile_modal_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n"
    ]);
    filters_mobile_modal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var StyledOverlay = (0,styled_components_browser_esm/* default */.ZP)(overlay/* default */.Z).withConfig({
    componentId: "sc-4574f44-0"
})(filters_mobile_modal_templateObject());
var StyledModal = (0,styled_components_browser_esm/* default */.ZP)(modal/* default.Standalone */.Z.Standalone).withConfig({
    componentId: "sc-4574f44-1"
})(filters_mobile_modal_templateObject1());
var StyledFilters = (0,styled_components_browser_esm/* default */.ZP)(Filters).withConfig({
    componentId: "sc-4574f44-2"
})(filters_mobile_modal_templateObject2());
function FiltersMobileModal(props) {
    var onClose = props.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOverlay, {
        open: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModal, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(floating_header/* FloatingHeader */.y, {
                    onClose: onClose,
                    title: "Filtros"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFilters, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                        onShowClick: onClose
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/filters/components/filters-mobile-modal/index.ts


;// CONCATENATED MODULE: ./src/components/filters/index.ts





// EXTERNAL MODULE: ./src/hooks/use-scroll-restoration.ts
var use_scroll_restoration = __webpack_require__(57299);
;// CONCATENATED MODULE: ./src/screens/search-beta/components/content-layout/empty-state-content.tsx

function empty_state_content_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        "px;\n  text-align: center;\n  width: ",
        "px;\n"
    ]);
    empty_state_content_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function empty_state_content_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: center;\n"
    ]);
    empty_state_content_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var StyledEmptyStateContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-de87d16b-0"
})(empty_state_content_templateObject(), function(props) {
    return props.theme.spacing.cozy * 2;
}, function(props) {
    return props.theme.spacing.cozy * 48.25;
});
var empty_state_content_StyledSelectedFilterTags = (0,styled_components_browser_esm/* default */.ZP)(SelectedFilterTags).withConfig({
    componentId: "sc-de87d16b-1"
})(empty_state_content_templateObject1());
function EmptyStateContent() {
    var selectedTags = (0,hooks/* useFilters */.mN)().selectedTags;
    var clearFilters = (0,use_filters_state/* useFiltersState */.$)().clearFilters;
    var hasSelectedTags = !(0,lodash.isEmpty)(selectedTags);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledEmptyStateContent, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: constants/* images.ILLUSTRATION_ONLINE_SHOP */.Wc.ILLUSTRATION_ONLINE_SHOP
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: "text-xl font-bold",
                children: "No se encontraron productos"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "No se encontraron productos que coincidan con tu b\xfasqueda. Intenta con menos filtros."
            }),
            hasSelectedTags && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(empty_state_content_StyledSelectedFilterTags, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Action */.aU, {
                            $color: "info",
                            onClick: function() {
                                return clearFilters();
                            },
                            children: "Limpiar todos los filtros"
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/screens/search-beta/components/content-layout/content-layout.tsx

function content_layout_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  min-height: calc(100vh - ",
        "px);\n  padding: ",
        "px;\n  width: 100%;\n\n  ",
        " {\n    min-height: calc(100vh - ",
        "px);\n  }\n"
    ]);
    content_layout_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var content_layout_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6743acae-0"
})(content_layout_templateObject(), function(props) {
    return props.theme.spacing.cozy * 38;
}, function(props) {
    return props.theme.spacing.cozy * 3;
}, (0,styled_breakpoints.up)("lg"), function(props) {
    return props.theme.spacing.cozy * 44;
});
function ContentLayout(props) {
    var networkStatus = props.networkStatus, render = props.render, dataSource = props.dataSource;
    if (networkStatus === bundle_esm/* NetworkStatus.loading */.Ie.loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(content_layout_Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Loader */.nt, {})
        });
    }
    if (networkStatus === bundle_esm/* NetworkStatus.error */.Ie.error) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(content_layout_Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* default */.Z, {
                as: "p",
                $textStyle: "h5Regular",
                children: "Hubo un problema inesperado."
            })
        });
    }
    if ((0,lodash.isEmpty)(dataSource)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(content_layout_Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyStateContent, {})
        });
    }
    return render();
}

;// CONCATENATED MODULE: ./src/screens/search-beta/components/content-layout/index.ts


;// CONCATENATED MODULE: ./src/screens/search-beta/components/content/content-desktop.tsx

function content_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  gap: ",
        "px;\n  grid-template-columns: ",
        ";\n  margin-top: ",
        "px;\n  padding-left: ",
        "px;\n  padding-right: ",
        "px;\n  width: 100%;\n"
    ]);
    content_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function content_desktop_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  & > div {\n    display: grid;\n    gap: ",
        "px;\n    grid-template-columns: 1fr;\n    padding: 0;\n\n    ",
        " {\n      grid-template-columns: ",
        ";\n    }\n\n    ",
        " {\n      grid-template-columns: ",
        ";\n    }\n  }\n"
    ]);
    content_desktop_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function content_desktop_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: ",
        "px;\n"
    ]);
    content_desktop_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}













var content_desktop_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cdd51adb-0"
})(content_desktop_templateObject(), function(props) {
    return props.theme.spacing.comfortable;
}, function(props) {
    return props.$hasFiltersPanel ? "".concat(props.theme.spacing.cozy * 35, "px 1fr") : "1fr";
}, function(props) {
    return props.theme.spacing.cozy;
}, function(props) {
    return props.theme.spacing.comfortable;
}, function(props) {
    return props.theme.spacing.comfortable;
});
var StyledCatalog = (0,styled_components_browser_esm/* default */.ZP)(components/* Catalog */.gm).withConfig({
    componentId: "sc-cdd51adb-1"
})(content_desktop_templateObject1(), function(props) {
    return props.theme.spacing.comfortable;
}, (0,styled_breakpoints.up)("lg"), function(props) {
    return props.$showCartInMainLayout ? "repeat(2, 1fr)" : "repeat(3, 1fr)";
}, (0,styled_breakpoints.up)("xl"), function(props) {
    return props.$showCartInMainLayout ? "repeat(3, 1fr)" : "repeat(4, 1fr)";
});
var content_desktop_StyledFilters = (0,styled_components_browser_esm/* default */.ZP)(Filters).withConfig({
    componentId: "sc-cdd51adb-2"
})(content_desktop_templateObject2(), function(props) {
    return props.theme.spacing.cozy / 2;
});
function ContentDesktop(props) {
    var networkStatus = props.networkStatus, onFetchMoreProducts = props.onFetchMoreProducts, paginationInfo = props.paginationInfo, products = props.products;
    var noFiltersAvailable = (0,use_filters_state/* useFiltersState */.$)().noFiltersAvailable;
    var isLoading = (0,hooks/* useFilters */.mN)().isLoading;
    var showCartInMainLayout = (0,toggled_esm/* useFlag */.P5)(constants/* flags.SHOW_CART_IN_MAIN_LAYOUT */.id.SHOW_CART_IN_MAIN_LAYOUT);
    (0,use_scroll_restoration/* useScrollRestoration */.p)();
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Loader */.nt, {});
    }
    var _page;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(content_desktop_StyledContainer, {
        $hasFiltersPanel: !noFiltersAvailable,
        children: [
            !noFiltersAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(content_desktop_StyledFilters, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentLayout, {
                dataSource: products,
                networkStatus: networkStatus,
                render: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCatalog, {
                        products: products,
                        $showCartInMainLayout: showCartInMainLayout,
                        isStandalone: true,
                        pagination: {
                            pageStart: (_page = paginationInfo.page) !== null && _page !== void 0 ? _page : 1,
                            hasMore: paginationInfo.hasNextPage,
                            initialLoad: true,
                            loadMore: (0,lodash.debounce)(onFetchMoreProducts, 500)
                        }
                    });
                }
            })
        ]
    });
}
/* harmony default export */ var content_desktop = (ContentDesktop);

;// CONCATENATED MODULE: ./src/screens/search-beta/components/content/content-mobile.tsx






function ContentMobile(props) {
    var products = props.products, networkStatus = props.networkStatus, paginationInfo = props.paginationInfo, onFetchMoreProducts = props.onFetchMoreProducts;
    (0,use_scroll_restoration/* useScrollRestoration */.p)();
    var _page;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentLayout, {
        dataSource: products,
        networkStatus: networkStatus,
        render: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Catalog */.gm, {
                products: products,
                pagination: {
                    pageStart: (_page = paginationInfo.page) !== null && _page !== void 0 ? _page : 1,
                    hasMore: paginationInfo.hasNextPage,
                    initialLoad: true,
                    loadMore: (0,lodash.debounce)(onFetchMoreProducts, 500)
                }
            });
        }
    });
}

;// CONCATENATED MODULE: ./src/screens/search-beta/components/content/content.tsx






function content_Content(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Media */.pU, {
        mobile: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentMobile, (0,_object_spread/* default */.Z)({}, props));
        },
        desktop: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(content_desktop, (0,_object_spread/* default */.Z)({}, props));
        }
    });
}

;// CONCATENATED MODULE: ./src/screens/search-beta/components/content/index.ts


// EXTERNAL MODULE: ./src/components/filters/components/sort-select/index.ts + 1 modules
var sort_select = __webpack_require__(86129);
;// CONCATENATED MODULE: ./src/screens/search-beta/components/header/header-desktop.tsx

function header_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  padding: ",
        "px;\n  padding-bottom: ",
        "px;\n  width: 100%;\n"
    ]);
    header_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function header_desktop_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  gap: ",
        "px;\n"
    ]);
    header_desktop_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var StyledHeaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-15bfb49e-0"
})(header_desktop_templateObject(), function(props) {
    return props.theme.spacing.comfortable;
}, function(props) {
    return props.theme.spacing.cozy;
});
var StyledHeaderActionsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-15bfb49e-1"
})(header_desktop_templateObject1(), function(props) {
    return props.theme.spacing.cozy * 1.5;
});
function HeaderDesktop(props) {
    var title = props.title, numOfHints = props.numOfHints;
    var hasProductSortingFF = (0,toggled_esm/* useFlag */.P5)(constants/* flags.PRODUCT_SORTING */.id.PRODUCT_SORTING);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeaderContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitleWithTotal, {
                    title: title,
                    total: numOfHints
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderActionsContainer, {
                    children: hasProductSortingFF && /*#__PURE__*/ (0,jsx_runtime.jsx)(sort_select/* SortSelect */.gB, {})
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/screens/search-beta/components/header/header-mobile.tsx


function header_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  padding: ",
        "px;\n  width: 100%;\n\n  > svg:first-child {\n    margin-right: ",
        "px;\n  }\n"
    ]);
    header_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function header_mobile_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  gap: ",
        "px;\n  padding-top: 0px;\n"
    ]);
    header_mobile_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











var header_mobile_StyledTitleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dc10ecc3-0"
})(header_mobile_templateObject(), function(props) {
    return props.theme.spacing.comfortable;
}, function(props) {
    return props.theme.spacing.cozy;
});
var StyledFiltersContainer = (0,styled_components_browser_esm/* default */.ZP)(header_mobile_StyledTitleContainer).withConfig({
    componentId: "sc-dc10ecc3-1"
})(header_mobile_templateObject1(), function(props) {
    return props.theme.spacing.cozy * 1.5;
});
function HeaderMobile(props) {
    var numOfHints = props.numOfHints, title = props.title;
    var router = (0,next_router.useRouter)();
    var noFiltersAvailable = (0,use_filters_state/* useFiltersState */.$)().noFiltersAvailable;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isFilterModalOpen = ref[0], setIsFilterModalOpen = ref[1];
    var hasProductSortingFF = (0,toggled_esm/* useFlag */.P5)(constants/* flags.PRODUCT_SORTING */.id.PRODUCT_SORTING);
    var onFilterModalOpen = function() {
        return setIsFilterModalOpen(true);
    };
    var onFilterModalClose = function() {
        return setIsFilterModalOpen(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(header_mobile_StyledTitleContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                        type: "arrow-left",
                        color: "black",
                        onClick: function() {
                            return router.back();
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitleWithTotal, {
                        title: title,
                        total: numOfHints
                    })
                ]
            }),
            !noFiltersAvailable && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFiltersContainer, {
                children: [
                    hasProductSortingFF && /*#__PURE__*/ (0,jsx_runtime.jsx)(sort_select/* SortSelect */.gB, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton, {
                        onClick: onFilterModalOpen
                    })
                ]
            }),
            !noFiltersAvailable && isFilterModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(FiltersMobileModal, {
                onClose: onFilterModalClose
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/screens/search-beta/components/header/header.tsx





function components_header_header_Header(props) {
    var numOfHints = props.numOfHints, title = props.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Media */.pU, {
        mobile: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMobile, {
                title: title,
                numOfHints: numOfHints
            });
        },
        desktop: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderDesktop, {
                title: title,
                numOfHints: numOfHints
            });
        }
    });
}

;// CONCATENATED MODULE: ./src/screens/search-beta/index.tsx

















function SearchBetaScreen(props) {
    var ref, ref1, ref2, ref3;
    var metaInfo = props.metaInfo, isCategoryPage = props.isCategoryPage, subcategoryName = props.subcategoryName, categoryName = props.categoryName, page = props.page;
    var ref4 = (0,use_filters_state/* useFiltersState */.$)(), fixedSerializedFilters = ref4.fixedSerializedFilters, serializedFilters = ref4.serializedFilters, term = ref4.term, setTotalOfResults = ref4.setTotalOfResults, sortBy = ref4.sortBy;
    var queryVariables = react.useMemo(function() {
        return (0,lodash.pickBy)({
            term: term,
            page: page,
            filters: (0,_to_consumable_array/* default */.Z)(fixedSerializedFilters).concat((0,_to_consumable_array/* default */.Z)(serializedFilters)),
            sortBy: sortBy
        }, function(item) {
            return !(0,lodash.isNil)(item);
        });
    }, [
        fixedSerializedFilters,
        page,
        serializedFilters,
        term,
        sortBy
    ]);
    var catalogSearchQueryResponse = (0,react_hooks_esm/* useQuery */.aM)(queries/* catalogSearchQuery */.pY, {
        variables: queryVariables,
        onError: function(apolloError) {
            return (0,utils/* notifySentry */.Yw)(apolloError);
        }
    });
    var ref5;
    var paginationInfo = (ref5 = (ref = catalogSearchQueryResponse.data) === null || ref === void 0 ? void 0 : (ref1 = ref.catalogSearch) === null || ref1 === void 0 ? void 0 : ref1.pageInfo) !== null && ref5 !== void 0 ? ref5 : {};
    var ref6;
    var products = (ref6 = (ref2 = catalogSearchQueryResponse.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.catalogSearch) === null || ref3 === void 0 ? void 0 : ref3.items) !== null && ref6 !== void 0 ? ref6 : [];
    var headerTitle = subcategoryName || categoryName || '"'.concat(term, '"');
    var onFetchMoreProducts = react.useCallback(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(page) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            catalogSearchQueryResponse.fetchMore({
                                updateQuery: utils/* queryUpdater */.c_,
                                variables: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queryVariables), {
                                    page: page
                                })
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(page) {
            return _ref.apply(this, arguments);
        };
    }(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        queryVariables
    ]);
    react.useEffect(function() {
        if (!(0,lodash.isNil)(paginationInfo.total)) {
            setTotalOfResults(paginationInfo.total);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        paginationInfo.total
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Meta */.h_, {
                title: metaInfo.title,
                image: metaInfo.image,
                url: metaInfo.url,
                description: metaInfo.description,
                asCanonical: isCategoryPage,
                prevPage: paginationInfo.hasPrevPage ? String(paginationInfo.page - 1) : null,
                nextPage: paginationInfo.hasNextPage ? String(paginationInfo.page + 1) : null
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* MainLayout */.Zn, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_header_header_Header, {
                        title: headerTitle,
                        numOfHints: paginationInfo.total
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(content_Content, {
                        products: products,
                        networkStatus: catalogSearchQueryResponse.loading ? bundle_esm/* NetworkStatus.loading */.Ie.loading : catalogSearchQueryResponse.networkStatus,
                        paginationInfo: paginationInfo,
                        onFetchMoreProducts: onFetchMoreProducts
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var search_beta = (SearchBetaScreen);

;// CONCATENATED MODULE: ./src/screens/search-beta/utils.ts
function getFixedSerializedFilters(options) {
    var filters = [];
    if (options.categoryName) {
        filters.push("category:".concat(options.categoryName));
    }
    if (options.subcategoryName) {
        filters.push("subcategory:".concat(options.subcategoryName));
    }
    return filters;
}

// EXTERNAL MODULE: ./src/utils/is-browser.ts
var is_browser = __webpack_require__(56372);
;// CONCATENATED MODULE: ./pages/search.tsx




















function SearchPage(props) {
    var hasAdvancedFiltersFF = (0,toggled_esm/* useFlag */.P5)(constants/* flags.ADVANCED_FILTERS */.id.ADVANCED_FILTERS);
    if (hasAdvancedFiltersFF) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Meta */.h_, (0,_object_spread/* default */.Z)({}, props.metaInfo)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(filters_provider/* FiltersProvider */.W, {
                    sortBy: props.sortBy,
                    term: props.term,
                    serializedInitialFilters: props.serializedInitialFilters,
                    serializedFixedInitialFilters: props.serializedFixedInitialFilters,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(search_beta, {
                        metaInfo: props.metaInfo,
                        isCategoryPage: props.isParentCategory,
                        page: props.page,
                        categoryName: props.categoryName,
                        subcategoryName: props.subcategoryName
                    })
                }, (0,_to_consumable_array/* default */.Z)(props.serializedFixedInitialFilters).concat([
                    props.term
                ]).filter(Boolean).join(","))
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Meta */.h_, (0,_object_spread/* default */.Z)({}, props.metaInfo)),
            /*#__PURE__*/ (0,react.createElement)(search, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                key: (0,_to_consumable_array/* default */.Z)(props.serializedFixedInitialFilters).concat([
                    props.term
                ]).filter(Boolean).join(",")
            }))
        ]
    });
}
var getCategoryMetaInfo = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(category, subcategory, context) {
        var metaInfo, overrides;
        function getCategoryPageMetaInfo() {
            var title = category.name;
            if (subcategory) {
                title = "".concat(title, " - ").concat(subcategory.name);
            }
            var ref, ref1, ref2;
            return {
                title: (ref = category === null || category === void 0 ? void 0 : category.seoTitle) !== null && ref !== void 0 ? ref : "".concat(title, " | ").concat(context.vendor.name),
                description: (ref2 = (ref1 = category === null || category === void 0 ? void 0 : category.seoDescription) !== null && ref1 !== void 0 ? ref1 : category === null || category === void 0 ? void 0 : category.description) !== null && ref2 !== void 0 ? ref2 : "Encuentra la mayor variedad de ".concat(category.name, " al mejor precio")
            };
        }
        return (0,tslib_es6.__generator)(this, function(_state) {
            metaInfo = (0,utils/* getMetaInfo */.R7)(context);
            overrides = getCategoryPageMetaInfo();
            return [
                2,
                (0,lodash.assign)(metaInfo, overrides)
            ];
        });
    });
    return function getCategoryMetaInfo(category, subcategory, context) {
        return _ref.apply(this, arguments);
    };
}();
var getInitialFilters = function(params) {
    var category = params.category, subcategory = params.subcategory;
    if (subcategory) {
        return {
            category: category.name,
            subcategory: subcategory.name
        };
    }
    return {
        category: category.name
    };
};
var getCategoryAndSubcategory = function(categoryData, subcategoryId) {
    var category = categoryData.vendor.category;
    var subcategories = category.subcategories;
    var subcategory;
    if (subcategoryId) {
        subcategory = (0,lodash.find)(subcategories, {
            encodedId: subcategoryId
        });
    }
    return {
        category: category,
        subcategory: subcategory
    };
};
SearchPage.getInitialProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(context) {
        var query, page, queryStrings, _filters, serializedInitialFilters, categoryId, subcategoryId, ref, categoryData, ref1, category, subcategory, categoryName, subcategoryName, hasAdvancedFiltersFF, serializedFixedInitialFilters, productFiltersQueryKey, commonProps, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = context.query;
                    if (query.term) {
                        (0,lodash.assign)(query, {
                            term: decodeURIComponent(query.term)
                        });
                    }
                    queryStrings = context.asPath.split("?")[1];
                    serializedInitialFilters = ((_filters = utils/* queryString.parse */.uM.parse(queryStrings).filters) !== null && _filters !== void 0 ? _filters : []).sort();
                    if ((0,lodash.isFinite)(query.page)) {
                        page = Number(query.page);
                    }
                    if (context.asPath.startsWith("/b/")) {
                        return [
                            2,
                            {
                                page: page,
                                term: query.term,
                                metaInfo: (0,utils/* getMetaInfo */.R7)(context),
                                serializedFixedInitialFilters: []
                            }
                        ];
                    }
                    categoryId = (0,lodash.last)((0,lodash.split)(query.category, "-"));
                    subcategoryId = (0,lodash.last)((0,lodash.split)(query.subcategory, "-"));
                    return [
                        4,
                        context.apolloClient.query({
                            query: queries/* categoryQuery */.Uj,
                            variables: {
                                encodedId: categoryId
                            }
                        })
                    ];
                case 1:
                    ref = _state.sent(), categoryData = ref.data;
                    ref1 = getCategoryAndSubcategory(categoryData, subcategoryId), category = ref1.category, subcategory = ref1.subcategory;
                    categoryName = category.name;
                    subcategoryName = subcategory === null || subcategory === void 0 ? void 0 : subcategory.name;
                    hasAdvancedFiltersFF = context.hasFlag(constants/* flags.ADVANCED_FILTERS */.id.ADVANCED_FILTERS);
                    serializedFixedInitialFilters = getFixedSerializedFilters({
                        categoryName: categoryName,
                        subcategoryName: subcategoryName
                    });
                    productFiltersQueryKey = (0,filters_queries/* getProductFiltersQueryKey */.p)(serializedFixedInitialFilters, query.term);
                    commonProps = {
                        page: page,
                        sortBy: query.sortBy,
                        serializedInitialFilters: serializedInitialFilters,
                        serializedFixedInitialFilters: serializedFixedInitialFilters
                    };
                    if (!(hasAdvancedFiltersFF && !is_browser/* default */.Z)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        context.queryClient.prefetchQuery(productFiltersQueryKey, {
                            staleTime: Infinity
                        })
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    _tmp = [
                        (0,_object_spread/* default */.Z)({}, commonProps)
                    ];
                    _tmp1 = {
                        categoryName: category.name,
                        subcategoryName: subcategory === null || subcategory === void 0 ? void 0 : subcategory.name
                    };
                    return [
                        4,
                        getCategoryMetaInfo(category, subcategory, context)
                    ];
                case 4:
                    return [
                        2,
                        _object_spread_props/* default.apply */.Z.apply(void 0, _tmp.concat((_tmp1.metaInfo = _state.sent(), _tmp1.isParentCategory = (0,lodash.isUndefined)(query.subcategory), _tmp1.initialFilters = getInitialFilters({
                            category: category,
                            subcategory: subcategory
                        }), _tmp1)))
                    ];
            }
        });
    });
    return function(context) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var pages_search = (SearchPage);


/***/ }),

/***/ 57299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useScrollRestoration; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);


function useScrollRestoration() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleRouteChangeStart = function() {
            sessionStorage.setItem("scrollPosition", String(window.scrollY));
        };
        var handleRouteChangeComplete = function() {
            var scrollPosition = sessionStorage.getItem("scrollPosition");
            if (scrollPosition) {
                window.scrollTo(0, parseInt(scrollPosition, 10));
            }
        };
        router.events.on("routeChangeStart", handleRouteChangeStart);
        router.events.on("routeChangeComplete", handleRouteChangeComplete);
        return function() {
            router.events.off("routeChangeStart", handleRouteChangeStart);
            router.events.off("routeChangeComplete", handleRouteChangeComplete);
        };
    }, [
        router
    ]);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [157,3409,9774,2888,179], function() { return __webpack_exec__(49484), __webpack_exec__(8266); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);